<template>
  <div class="container">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr />
          <th scope="col">{{ name }}</th>
          <th scope="col">{{ imagesCell }}</th>
          <th
            scope="col"
            v-for="field of filledFields"
            :key="`${field.id}_header`"
          >
            {{ localeService.getTranslatedParam(field.name) }}
          </th>
          <th scope="col">{{ priceCell }}</th>
        </thead>

        <tbody>
          <tr v-for="lead of renderParams.leads" :key="lead.id">
            <td>{{ presentationName(lead) }}</td>
            <Images
              :lead="lead"
              :config="renderParams.config"
              :agent="renderParams.agent"
              :version="version"
            />
            <ValueCell
              v-for="field of filledFields"
              :key="field.id"
              :fieldId="field.id"
              :lead="lead"
              :localeService="localeService"
              :dateFormat="renderParams.date"
              :renderParams="renderParams"
            />
            <Price
              :lead="lead"
              :config="renderParams.config"
              :currency="renderParams.currency"
              :hidingConfig="renderParams.hidingFieldsConfig"
              :version="version"
              :currencyDict="renderParams.currencyDict"
            />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Images from '../../common/Images/Images.vue'
import ValueCell from './ValueCell.vue'
import Price from '../../common/Price.vue'
import Locale from '../../../../services/locale'

export default {
  name: 'ObjectsTable',
  props: {
    renderParams: Object,
    leads: Array,
    version: String,
    localeService: Locale,
  },
  components: {
    Images,
    ValueCell,
    Price,
  },
  computed: {
    name() {
      return this.localeService.getConstantTranslationByKey('name')
    },
    imagesCell() {
      return this.localeService.getConstantTranslationByKey('images')
    },
    priceCell() {
      return this.localeService.getConstantTranslationByKey('price')
    },
    budgetName() {
      return this.renderParams.hidingFieldsConfig?.budgetName || 'Комиссия'
    },
    filledFields() {
      const { optionsNames, leads } = this.renderParams

      return optionsNames
        .filter((o) => {
          if (o.id === 1) return true
          return leads.filter((l) =>
            l.custom_fields_values?.find(
              (cf) => cf.field_id === o.id && cf.values,
            ),
          ).length
        })
        .map((o) => ({
          ...o,
          name: o.id === 1 ? this.budgetName : o.name?.split('#')[0].trim(),
        }))
    },
  },
  methods: {
    presentationName(lead) {
      const presentationNameField = lead.custom_fields_values?.find(
        (cf) =>
          cf.field_id === this.renderParams?.config?.presentationNameFieldId,
      )
      return presentationNameField?.values[0].value || lead.name
    },
  },
}
</script>

<style scoped>
@import '../../../../assets/table-personal-agent.css';

thead th {
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  color: #484848;
  margin-right: 8px;

  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table-responsive {
  min-height: calc(100vh - (205px + 40px));
}
tbody {
  border-top: 2px solid #dee2e6 !important;
}

tbody >>> :last-child * {
  border-bottom-width: 0 !important;
}
</style>
